import color from "../../../../../constants/color";

const styles = {
  headTitle: {
    ml: 1,
    fontWeight: "600",
    fontSize: "18px",
    color: color.text
  },
  subTitle: {
    fontWeight: "500",
    fontSize: "14px",
    color: color.text,
    ml: 2
  },
  mobileGrid: {
    "& .MuiOutlinedInput-root": {
      height: "2.9em",
      marginTop: "0.5em",
      borderRadius: "10px",
      width: "100%",
    },
    ".react-tel-input": {
      width: "100%",
      "& .selected-flag": {
        "& .flag": {
          mt: "-9px",
        }
      },
      ".form-control": {
        borderRadius: "10px",
        mt: "7px",
        // height: "2.5em", // Match height with MUI input
        width: "100%",

      },
    },
  },

  btnGridAction: {
    width: "100%",
    ml: { xs: 1, md: 0 }
  },

  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary,
    textAlign: "center"
  },
  deleteIcons: {
    p: 1,
    // pb:0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"

  },


  card: {
    backgroundColor: "#fff",
    margin: 2,
    borderRadius: "20px",
    pr: 2,
    paddingBottom: "25px",
    "& .css-a5rdam-MuiGrid-root": {
      marginTop: "11px",
    }
  },
  mainGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "top",
    mt: 2,
    mr: 2
  },
  dropDownMenu: {
    fontSize: "14px",
    fontWeight: "400",
  },
  dropDown: {
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8px 14px",
    },

  },

  table: {
    border: "1px solid #F5F5F5"
  },
  formControl: {
    "& .MuiOutlinedInput-root": {
      height: "2.9em",
      my: "0.5em",
      borderRadius: "10px",
    },
  },
  line: {
    backgroundColor: "#28AA4A",
    width: "2%",
    height: 2
  },

  boxGrid: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ml: "2%",
    my: "2%"
  },
  pensionGrid: {
    display: "flex",
    alignItems: "center",
    mt: 2
  },
  pensionHeading: {
    fontSize: "18px",
    fontWeight: "600",
    color: color.text,
    mt: 2
  },
  addBtn: {
    fontSize: "12px",
    borderRadius: 50,
    textTransform: "none",
    color: color.card,
    backgroundColor: color.primary,
    // fontWeight: "500",
    px: 4,
    ml: 4,
    "&:hover": {
      color: color.card,
      backgroundColor: color.primary,

    }

  },


  pensionText: {
    width: "40%"
  },
  medicalTxt: {
    fontSize: "14px",
  },
  labels: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mb: 1
  },

  dropdown: {
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p: 0,
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      p: 1
    }
  },
  dropdowns: {
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p: 0,
    ml: 1,
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      p: 1
    }
  },

  YearsInput:{
    width: "100%",

  },
  dateInput: {
    width: "100%",
    mt:1,

    // padding:2,
    "& .css-6193sp-MuiInputBase-root-MuiOutlinedInput-root ": {
      borderRadius: "8px",
    },
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },
  label: {
    fontSize: "12px",
    fontWeight: "400",
    // color:color.text
  },
  mobile: {
    "&  .react-tel-input": {
      " .form-control": {
        width: "100%"
      }
    },
  },
  formControlLabel: {
    m: 0,
    " & .css-1ismtrt-MuiTypography-root": {
      fontSize: "14px",
      width: "100%",
    }
  },
  submitButton: {
    borderRadius: 50,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: color.primary,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "8px",
    },
  },
  textsize: {
    fontSize: "13px",
  },
  textside: {
    fontSize: "13px",
    ml: "35px"
  },
  addIcons: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary,
    display: "flex",
    justifyContent: "center",
    my: "0.5em",


  },
  deleteIcon: {
    p: 1,
    // pb: 0,
    backgroundColor: "#FBD6D6",
    borderRadius: "5px",
    color: color.red,
    display: "flex",
    justifyContent: "center",
    my: "0.5em",



  },
  checkoutBtn: {
    borderRadius: 50,
    backgroundColor: "#28AA4A",
    color: "#fff",
    // ml: "8px",
    textTransform: "none",
    fontSize: "12px",
    boxShadow: "none"
  },

  setupAlert: {
    mx: "2%",
    mt: 2,
    borderRadius: "10px",
    borderWidth: 2,
    fontWeight: 500,
  },
  setupAlertList: {
    m: 0,
    mt: 1,
    pl: 3,
  },
};

export default styles;
